import type { ThemePalette } from "./types";

export const gruvboxDark: ThemePalette = {
	id: "gruvbox-dark",
	name: "Gruvbox Dark",
	family: "gruvbox",
	appearance: "dark",

	background: "#282828",
	foreground: "#ebdbb2",
	card: "#3c3836",
	cardForeground: "#ebdbb2",
	popover: "#3c3836",
	popoverForeground: "#ebdbb2",

	primary: "#fe8019",
	primaryForeground: "#282828",
	secondary: "#504945",
	secondaryForeground: "#ebdbb2",
	muted: "#504945",
	mutedForeground: "#a89984",
	accent: "#8ec07c",
	accentForeground: "#282828",
	destructive: "#fb4934",
	destructiveForeground: "#282828",

	border: "#504945",
	input: "#504945",
	ring: "#fe8019",

	success: "#b8bb26",
	warning: "#fabd2f",
	error: "#fb4934",
	info: "#83a598",

	chart1: "#fe8019",
	chart2: "#83a598",
	chart3: "#d3869b",
	chart4: "#8ec07c",
	chart5: "#b8bb26",
};

export const gruvboxLight: ThemePalette = {
	id: "gruvbox-light",
	name: "Gruvbox Light",
	family: "gruvbox",
	appearance: "light",

	background: "#fbf1c7",
	foreground: "#3c3836",
	card: "#ebdbb2",
	cardForeground: "#3c3836",
	popover: "#ebdbb2",
	popoverForeground: "#3c3836",

	primary: "#d65d0e",
	primaryForeground: "#fbf1c7",
	secondary: "#d5c4a1",
	secondaryForeground: "#3c3836",
	muted: "#d5c4a1",
	mutedForeground: "#7c6f64",
	accent: "#689d6a",
	accentForeground: "#fbf1c7",
	destructive: "#cc241d",
	destructiveForeground: "#fbf1c7",

	border: "#d5c4a1",
	input: "#d5c4a1",
	ring: "#d65d0e",

	success: "#98971a",
	warning: "#d79921",
	error: "#cc241d",
	info: "#458588",

	chart1: "#d65d0e",
	chart2: "#458588",
	chart3: "#b16286",
	chart4: "#689d6a",
	chart5: "#98971a",
};
